module.exports = __webpack_public_path__ + "static/media/mode-02.4215568e.jpg";